export const server = 'https://we-designe-tees-backend.vercel.app/api/v2'
export const backend_url = "https://we-designe-tees-backend.vercel.app/";
// export const server = 'http://localhost:7000/api/v2'
// export const backend_url = "http://localhost:7000/";